module.exports = __webpack_public_path__ + "img/qr_code.4d3d3f56.svg";